import ajax from '@assets/js/interceptor';
import util from '@assets/js/util';
import { getTableData, getDepartmentDataByOperableDepart, getDepartmentData } from '@/api/userManage';
const departmentUrl = '/v1/departments/flatTreeOrgan';
export default {
  namespaced: true,
  state: {
    treeData: [],
    activedTree: {},
    totalCount: 0,
    dataSource: []
  },
  mutations: {
    SAVE_STATE (state, payload = {}) {
      // 由于不想全部把state给改了，所以我想把每一个数据都单独塞一下
      const keyList = Object.keys(payload);
      keyList.forEach(key => {
        state[key] = payload[key];
      });
    }
  },
  actions: {
    getUserPermission ({ commit, dispatch, state }, payload) {
      // ajax.get('www.aldf.com');
    },
    getTableInfo ({ commit, dispatch, state }, { filter }) {
      const pasFilter = { ...filter, duplicate: 1 };
      getTableData(pasFilter).then(res => {
        const { code, data } = res.data;
        if (code == 200) {
          commit('SAVE_STATE', { dataSource: data.records, totalCount: data.total });
        }
      });
    },
    getTreeList ({ commit, dispatch, state }, payload) {
      const initData = { id: 'all', title: '全部', pid: null, toggleOpen: false, active: false, level: 0 };
      return new Promise(resolve => {
        ajax.get(departmentUrl, { domainType: 'orgApi' }).then(res => {
          const { code, data } = res.data;
          if (code == 200) {
            const dataMap = data.map(item => {
              const { childDepartmentId, childDepartmentName, departmentId, ...rest } = item;
              return {
                id: childDepartmentId,
                title: childDepartmentName,
                pid: departmentId,
                toggleOpen: false,
                active: false,
                level: 0,
                ...rest
              };
            });
            const addIntiData = [initData, ...dataMap];
            const treeData = util.getMenuTree(addIntiData);
            commit('SAVE_STATE', { treeData });
            resolve({ originData: dataMap, treeData });
          }
        });
      });
    },
    // 自定义部门的数据
    getDepartmentInfo ({ commit, dispatch, state }, payload) {
      // selectedIds放relationid 转成id传给compareListToChecked
      const { selectedIds } = payload;
      return new Promise(resolve => {
        getDepartmentData().then(res => {
          const { code, data } = res.data;
          if (code == 200) {
            const dataMap = data.map(item => {
              const { childDepartmentId, childDepartmentName, departmentId, checked, relationId, ...rest } = item;
              return {
                ...rest,
                relationId,
                id: childDepartmentId,
                title: childDepartmentName,
                pid: departmentId,
                toggleOpen: false,
                active: false,
                checked: false, // 需要给个初始值
                level: 0
              };
            });
            util.compareListToChecked(dataMap, selectedIds);
            const addIntiData = [...dataMap];
            const treeData = util.getMenuTree(addIntiData);
            resolve({ originData: dataMap, treeData });
          }
        });
      });
    },
    // 根据可用的部门信息获取自定义部门的数据
    getDepartmentInfoByOperableDepartment ({ commit, dispatch, state }, payload) {
      // 放的operableId
      const { selectedIds, operableIds } = payload;
      const operableString = operableIds.join(',');
      return new Promise(resolve => {
        getDepartmentDataByOperableDepart(operableString).then(res => {
          const { code, data } = res.data;
          if (code == 200) {
            const dataMap = data.map(item => {
              const { childDepartmentId, childDepartmentName, departmentId, checked, ...rest } = item;
              return {
                ...rest,
                id: childDepartmentId,
                title: childDepartmentName,
                pid: departmentId,
                toggleOpen: false,
                active: false,
                disableCheckbox: true, // 先把所有信息设为不可选
                checked: false, // 需要给个初始值
                level: 0
              };
            });
            // 找到可选信息设为可选
            util.compareListToCheckable(dataMap, operableIds);
            // 找到已选信息设为已选
            util.compareListToChecked(dataMap, selectedIds);
            const addIntiData = [...dataMap];
            const { treeData, relationIdMap } = util.getDataAndMap(addIntiData);
            resolve({ originData: dataMap, treeData, treeMapData: relationIdMap });
          }
        });
      });
    }
  }
};
